// React
import React from "react";

// Material UI
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Stack,
} from "@mui/material";
import {
  LogoutRounded,
  PersonRounded,
  LanguageRounded,
  LockRounded,
} from "@mui/icons-material";

// Resources
import {
  terracotta,
  hoverTerracotta,
  offWhite,
} from "Constants/ColourConstants";
import { useTranslation } from "react-i18next";

// Redux
import { useSelector } from "react-redux";
import { selectUserEmail } from "Store/AuthSlice";

const AvatarMenu = ({
  anchorEl,
  handleMenuClick,
  handleMenuClose,
  handleChangePasswordNavigate,
  handleOpenLanguage,
  handleSignOut,
}) => {
  const { t } = useTranslation();
  const userEmail = useSelector(selectUserEmail);

  return (
    <div>
      <IconButton
        aria-owns={anchorEl ? "account-menu" : undefined}
        aria-haspopup="true"
        onClick={handleMenuClick}
        size="large"
        sx={{
          color: terracotta,
          backgroundColor: offWhite,
          width: "45px",
          height: "45px",
          "&:hover": {
            backgroundColor: hoverTerracotta,
          },
        }}
      >
        <PersonRounded fontSize="inherit" />
      </IconButton>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem disabled sx={{ "&.Mui-disabled": { opacity: 0.5 } }}>
          <ListItemIcon>
            <PersonRounded fontSize="small" />
          </ListItemIcon>
          <ListItemText>{userEmail}</ListItemText>
        </MenuItem>
        <Divider />
        {handleChangePasswordNavigate && (
          <Stack>
            <MenuItem onClick={handleChangePasswordNavigate}>
              <ListItemIcon>
                <LockRounded fontSize="small" />
              </ListItemIcon>
              <ListItemText>Change Password</ListItemText>
            </MenuItem>
            <Divider />
          </Stack>
        )}
        {handleOpenLanguage && (
          <Stack>
            <MenuItem onClick={handleOpenLanguage}>
              <ListItemIcon>
                <LanguageRounded fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t("common.language")}</ListItemText>
            </MenuItem>
            <Divider />
          </Stack>
        )}
        {handleSignOut && (
          <MenuItem onClick={handleSignOut}>
            <ListItemIcon>
              <LogoutRounded fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("autoSignOut.signOut")}</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default AvatarMenu;
